module.exports = __webpack_public_path__ + "static/DSC_9483-2b8e2171f43c509e191871b709b2a9fb.jpg";